class xidianMapLine {
  constructor(opt) {
    this.vm = opt.vm
  }
  async changeLineData(opt) {
    this.vm.chartOption.lines.dataHasZero = true
  }
}
export default {
  data() {
    return {
      xidianMapLine: new xidianMapLine({
        vm: this
      })
    }
  },
  methods: {
    async xidianMapLinePlugin(opt) {
      this.xidianMapLine.changeLineData(opt) //初始化
    },
    lineDataZeroFunc(opt1, symbolDirection){
      let seriesLines = opt1.series.find(item=> item.type === "lines")
      let lineDataCopy = JSON.parse(JSON.stringify(seriesLines.data)), lineData = []
      if(symbolDirection === "converge" && typeof lineDataCopy[0][0].value !== "string"){
        return opt1
      } else if(symbolDirection === "spread" && typeof lineDataCopy[0][1].value !== "string"){
        return opt1
      }
      let centerPointVal0 = false
      if((symbolDirection === "converge" && !Number(lineDataCopy[0][0].value2)) || (symbolDirection === "spread" && !Number(lineDataCopy[0][1].value2))){
        centerPointVal0 = true
      }
      opt1.visualMap = { //图例值控制
        min: 0,
        show: false,
        pieces: [{
          gte: 1,
          label: ">= 1",
          color: centerPointVal0 ? "rgba(0,0,0,0)" : seriesLines.lineStyle.color
        }, {
          lt: 1,
          label: "0",
          color: "rgba(0,0,0,0)"
        }]
      }
      for(let i = 0; i < lineDataCopy.length; i++){
        let item = lineDataCopy[i]
        //  获取第三组数据值：目前固定取属性值value2
        if(symbolDirection === "converge"){
          let item1 = {
            coord: item[0].coord,
            value: item[0].value2,
            value2: item[0].value,
          }
          let arrNew = []
          arrNew.push(item1)
          arrNew.push(item[1])
          lineData.push(arrNew)
        }else{
          let item1 = {
            coord: item[1].coord,
            value: item[1].value2,
            value2: item[1].value,
          }
          let arrNew = []
          arrNew.push(item[0])
          arrNew.push(item1)
          lineData.push(arrNew)
        }
      }
      seriesLines.data = lineData
      let formatter1 = (param) =>{
        return param.data.value2
      }
      seriesLines.label.formatter = formatter1
      return opt1
    }
  },
  beforeDestroy() {

  },
  beforeUpdate() {

  }
}
